import classNames from 'classnames'

import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'
import { appendP360TabScrollIntent } from 'partner360/lib/tabScrollIntent'

import { TRANSLATION_KEYS } from './translations'
import { usePartnerPlanUrl } from './usePartnerPlanUrl'

import styles from './PartnerNameWithLink.module.scss'

interface IPartnerNameWithLinkProps {
  partnerId: string
  partnerName: string
  programType?: string
  tabUrl?: string
  isGlobal?: boolean
  fYear?: number
  shouldScrollToTab?: boolean
  preserveCurrentUrlParams?: boolean
  /** Extra classes for the anchor, for callers whose cell imposes its own layout — the cockpit's
   *  hierarchy tables restore their `text-overflow: ellipsis` through this. Additive: omitting it
   *  leaves the link exactly as every other caller renders it. */
  className?: string
  /** An extra line rendered above the "Open partner plan" hint in the hover card. The cockpit's
   *  hierarchy tables pass the untruncated partner name here, since their cell shows a shortened
   *  one. Additive: omitting it leaves the tooltip exactly as every other caller renders it. */
  tipTitle?: string
}

export const PartnerNameWithLink = ({
  partnerId,
  partnerName,
  programType,
  tabUrl,
  isGlobal,
  fYear,
  shouldScrollToTab = false,
  preserveCurrentUrlParams,
  className,
  tipTitle,
}: IPartnerNameWithLinkProps) => {
  const partnerUrl = usePartnerPlanUrl({
    partnerId,
    programType,
    tabUrl,
    isGlobal,
    fYear,
    preserveCurrentUrlParams,
  })

  return (
    <Tooltip
      tipContent={() => (
        <>
          {tipTitle ? <div>{tipTitle}</div> : null}
          <Translation text={TRANSLATION_KEYS.openPartnerPlan} />
        </>
      )}
    >
      <a
        className={classNames(styles.link, className)}
        href={shouldScrollToTab ? appendP360TabScrollIntent(partnerUrl) : partnerUrl}
        target={'_blank'}
        rel="noreferrer"
      >
        <div>{partnerName}</div>
      </a>
    </Tooltip>
  )
}
